import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCondicionLinea3Actions'
import { TablaDetallePorCondicionLinea3View } from '../components/TablaDetallePorCondicionLinea3View'

class TablaDetallePorCondicionLinea3 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCondicionLinea3View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCondicionLinea3)
